import * as React from "react";
import type { SVGProps } from "react";
const SvgSkiPass = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.11 12.45A1 1 0 0 0 8 13a.93.93 0 0 0 .45-.11L11 11.62V14a1 1 0 0 0 2 0v-2.38l2.55 1.27A.93.93 0 0 0 16 13a1 1 0 0 0 .45-1.89L14.24 10l2.21-1.11a1 1 0 1 0-.9-1.78L13 8.38V6a1 1 0 0 0-2 0v2.38L8.45 7.11a1 1 0 0 0-.9 1.78L9.76 10l-2.21 1.11a1 1 0 0 0-.44 1.34M7.293 16.293A1 1 0 0 1 8 16h8a1 1 0 0 1 0 2H8a1 1 0 0 1-.707-1.707"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 0h-4a1 1 0 0 0-1 1 1 1 0 0 1-2 0 1 1 0 0 0-1-1H6a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h4a1 1 0 0 0 1-1 1 1 0 0 1 2 0 1 1 0 0 0 1 1h4a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3m1 21a1 1 0 0 1-1 1h-3.17a3 3 0 0 0-5.66 0H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3.17a3 3 0 0 0 5.66 0H18a1 1 0 0 1 1 1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSkiPass;
